<template lang="pug">
.insights-proficiency-ranking-widget.widget-panel
  .widget-common.widget-small
    .widget-title
      | {{ label }}
    .widget-body
      template(v-if="hasData")
        .d-flex.align-items-center.ranking-row(
          v-for="row in ranking.data"
          :key="row.user_id"
        )
          InsightsProficiencyBadge(
            :score="row.core_time"
            size="small"
          )
          .ranking-name.ml-10 {{ row.user_name }}
      InsightsNoData(
        v-else
        type="no_data"
      )
</template>

<script>
import InsightsProficiencyBadge from './InsightsProficiencyBadge.vue';

export default {
  name: 'InsightsProficiencyRankingWidget',
  components: {
    InsightsProficiencyBadge,
    InsightsNoData: () => import('~/components/insights/InsightsNoData.vue'),
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    ranking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasData() {
      return !!(this.ranking && this.ranking.data && this.ranking.data.length);
    },
  },
};
</script>
